import { z } from 'zod';
import { PaymentTermsSettingsSchema } from '@/shared/models/ContextDataModel/interfaces/entities/finance-settings.ts';

export function getFinanceSettingsFormSchema(params?: {
    errorMessage?: string;
    billingTextMaxLengthErrorMessage?: string;
}) {
    const errorMessage = params?.errorMessage;

    const FinanceSettingSchema = z
        .object({
            debtorOrganizationId: z.number({ message: errorMessage }),
            creditorOrganizationId: z.number({ message: errorMessage }),
            billingText: z.string().max(255, params?.billingTextMaxLengthErrorMessage).nullable(),
        })
        .and(
            z.discriminatedUnion(PaymentTermsSettingsSchema.discriminator, PaymentTermsSettingsSchema.options, {
                message: errorMessage,
            })
        );

    return z.object({
        financeSettings: z.array(FinanceSettingSchema),
    });
}

export type FinanceSettingsFormValues = z.infer<ReturnType<typeof getFinanceSettingsFormSchema>>;
